/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { createAgent } from "@vlinder-web/plugin-agent-service-react";
import {
  HeaderService,
  IHeaderMethods,
  SettingsService,
  ISettingsMethods,
  PresentationListService,
  IPresentationListMethods,
  IStaticPageContentMethods,
  StaticPageContentService,
  CreatePresentationService,
  ICreatePresentationMethods,
  IUpdatePresentationMethods,
  UpdatePresentationService,
  DeletePresentationService,
  IDeletePresentationMethods,
} from "./components";

export type PresentationListPageAgent = IHeaderMethods &
  ISettingsMethods &
  IStaticPageContentMethods &
  ICreatePresentationMethods &
  IPresentationListMethods &
  IUpdatePresentationMethods &
  IDeletePresentationMethods;

const getPlugins = () => {
  return [
    new StaticPageContentService(),
    new HeaderService(),
    new SettingsService(),
    new CreatePresentationService(),
    new PresentationListService(),
    new UpdatePresentationService(),
    new DeletePresentationService(),
  ];
};

export const getAgent = () => {
  return createAgent<PresentationListPageAgent>({
    plugins: getPlugins(),
  });
};
